"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var react_1 = require("swiper/react");
var modules_1 = require("swiper/modules");
var SwiperNavArrows_1 = require("../../Swiper/SwiperNavArrows");
var hooks_1 = require("preact/hooks");
var shop_carousel_1 = require("../../utils/shopify-graphql/shop-carousel");
var ShopCarousel = function () {
    var _a = (0, hooks_1.useState)(null), shopCarouselData = _a[0], setShopCarouselData = _a[1];
    var _b = (0, hooks_1.useState)('capsule'), selectedOption = _b[0], setSelectedOption = _b[1];
    var _c = (0, hooks_1.useState)(null), thumbsSwiper = _c[0], setThumbsSwiper = _c[1];
    var _d = (0, hooks_1.useState)(0), imageIndex = _d[0], setImageIndex = _d[1];
    window.addEventListener('capsule', function () {
        setSelectedOption('capsule');
    });
    window.addEventListener('gummy', function () {
        setSelectedOption('gummy');
    });
    (0, hooks_1.useEffect)(function () {
        var url = window.location;
        var handle = url.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        (0, shop_carousel_1.getShopCarouselData)(handle)
            .then(function (data) {
            if (data) {
                setShopCarouselData(data);
            }
        })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (shopCarouselData) {
        return ((0, preact_1.h)(preact_1.Fragment, null,
            (0, preact_1.h)(react_1.Swiper, { class: "shop-carousel-main", loop: true, modules: [modules_1.FreeMode, modules_1.Thumbs], onRealIndexChange: function (swiper) { return setImageIndex(swiper.realIndex); }, thumbs: { swiper: thumbsSwiper } },
                (0, preact_1.h)(SwiperNavArrows_1.default, { color: shopCarouselData.theme }),
                shopCarouselData[selectedOption].map(function (node) {
                    var _a;
                    return ((0, preact_1.h)(react_1.SwiperSlide, { key: "".concat(node.id, "-main") },
                        (0, preact_1.h)("img", { alt: "", class: "shop-carousel-main-image", src: (_a = node.image) === null || _a === void 0 ? void 0 : _a.url })));
                })),
            (0, preact_1.h)(react_1.Swiper, { class: "shop-carousel-thumbnail", freeMode: true, loop: true, modules: [modules_1.FreeMode, modules_1.Thumbs], onSwiper: setThumbsSwiper, slidesPerView: shopCarouselData.gummy.length, watchSlidesProgress: true }, shopCarouselData[selectedOption].map(function (node, index) {
                var _a;
                return ((0, preact_1.h)(react_1.SwiperSlide, { key: "".concat(node.id, "-thumbnail") },
                    (0, preact_1.h)("img", { alt: "", class: "shop-carousel-thumbnail-image ".concat(shopCarouselData.theme, " ").concat(index === imageIndex && 'shop-carousel-thumbnail-image--active'), src: (_a = node.image) === null || _a === void 0 ? void 0 : _a.url })));
            }))));
    }
    else {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
};
exports.default = ShopCarousel;
